<template>
  <!-- 保单列表组件 -->
  <div class="insurancelist">
    <!-- 灾害列表  搜索有数据 -->
    <div class="hasData" v-if="isShow">
      <el-table
        empty-text=" "
        v-loading="loading"
        :data="list"
        stripe
        :row-class-name="TableRow"
        :header-cell-style="{ color: '#64C3A4', fontSize: '16px' }"
        :cell-style="{ color: '#666666' }"
      >
        <el-table-column label="地块编码" width="180px" prop="shGisDkid">
          <template slot-scope="scope">
            {{ scope.row.shGisDkid || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="地块名称" width="215px" prop="landName">
          <template slot-scope="scope">
            {{ scope.row.landName || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="地块用途" width="130px">
          <template slot-scope="scope">
            {{ scope.row.gisLandTypeName || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="栽培类型" width="130px">
          <template slot-scope="scope">
            {{ cultivation_type[scope.row.cultivationType] }}
          </template>
        </el-table-column>
        <el-table-column label="地块面积（亩）" width="150px" prop="landAcre" />
        <el-table-column
          label="种植作物"
          width="130px"
          prop="cropName"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.cropName || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="受灾程度" width="120px">
          <template slot-scope="scope">
            {{ damage_level[scope.row.level] }}
          </template>
        </el-table-column>
        <el-table-column label="经济损失（元）" width="135px" prop="damage" />
        <el-table-column label="受灾图片" width="150px">
          <template slot-scope="scope">
            <el-image
              v-for="(img, idx) in scope.row.imgUrls.split(',')"
              :key="img"
              :src="img"
              class="imgWrap"
              :preview-src-list="scope.row.imgUrls.split(',')"
              :initial-index="idx"
            />
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="备注" width="130px">
          <template slot-scope="scope">
            {{ scope.row.remark || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="申报时间" width="180px" prop="reportTime">
          <template slot-scope="scope">
            {{ scope.row.reportTime || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="申报人" width="100px">
          <template slot-scope="scope">
            {{ scope.row.reportOperator || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="镇审核状态" width="120px">
          <template slot-scope="scope">
            <div :class="`status${scope.row.townReviewStatus}`">
              {{ process_status[scope.row.townReviewStatus] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="镇审核时间" width="180px">
          <template slot-scope="scope">
            {{
              scope.row.townReviewTime || "--" | formatDate("yyyy-MM-dd hh:mm")
            }}
          </template>
        </el-table-column>
        <el-table-column label="镇审核人" width="100px">
          <template slot-scope="scope">
            {{ scope.row.townReviewOperator || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="镇审核意见" width="130px" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.townReviewComments || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="区审核状态" width="120px">
          <template slot-scope="scope">
            <div :class="`status${scope.row.countyReviewStatus}`">
              {{ process_status[scope.row.countyReviewStatus] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="区审核时间" width="180px">
          <template slot-scope="scope">
            {{
              scope.row.countyReviewTime ||
              "--" | formatDate("yyyy-MM-dd hh:mm")
            }}
          </template>
        </el-table-column>
        <el-table-column label="区审核人" width="100px">
          <template slot-scope="scope">
            {{ scope.row.countyReviewOperator || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="区审核意见" width="130px" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.countyReviewComments || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="市审核状态" width="100px">
          <template slot-scope="scope">
            <div :class="`status${scope.row.cityReviewStatus}`">
              {{ process_status[scope.row.cityReviewStatus] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="市审核时间" width="180px">
          <template slot-scope="scope">
            {{
              scope.row.cityReviewTime || "--" | formatDate("yyyy-MM-dd hh:mm")
            }}
          </template>
        </el-table-column>
        <el-table-column label="市审核人" width="100px">
          <template slot-scope="scope">
            {{ scope.row.cityReviewOperator || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="市审核意见" width="130px" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.cityReviewComments || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120px" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="isShowBtn(scope.row)"
              @click="checkContent(scope.row)"
              type="text"
              size="small"
              class="button14"
            >
              重新申报
            </el-button>
            <el-button
              v-if="isShowBtntwo(scope.row)"
              @click="openDialog(scope.row)"
              type="text"
              size="small"
              class="button14"
            >
              上调受灾程度
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 搜索后无数据 -->
    <div class="noDataImg" v-else>
      <div class="imgNo">
        <img src="~@/assets/images/damageImg/noData.png" alt="" />
      </div>
      <p style="color: #333">未找到符合条件的数据</p>
    </div>
    <el-dialog
      title="上调受灾程度"
      :visible.sync="dialogVisible"
      append-to-body
      width="30%"
      :before-close="handleClose"
    >
      <p class="title_p">请注意，上调受灾程度后，该地块将重新进入审核流程。</p>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="受灾程度" prop="level">
          <el-select
            v-model="ruleForm.level"
            clearable
            placeholder="请选择受灾程度"
          >
            <el-option
              v-for="({ label, value }, index) in option"
              :key="index"
              :label="label"
              :value="value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitData('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import sameIn from "@/mixins/listsdetails.js";
import {
  cultivation_type,
  damage_level,
  process_status,
} from "@/confing/map_tab.js";
import { raisedLevel } from "@/api/request/snkd.produce";
import { mapActions } from "vuex";

export default {
  name: "TableList",
  mixins: [sameIn],
  computed: {
    isShowBtn() {
      return (row) => {
        return (
          row.countyReviewStatus === 2 ||
          row.cityReviewStatus === 2 ||
          row.townReviewStatus === 2
        );
      };
    },
  },
  data() {
    return {
      maxHeignt: 500,
      process_status,
      cultivation_type,
      damage_level,
      policyColor: {
        10: "colorHui",
        40: "colorHui",
      },
      dialogVisible: false,
      ruleForm: {
        level: "",
        id: "",
        userName: "",
      },
      option: [
        {
          label: "成灾",
          value: "MEDIUM",
        },
        {
          label: "绝收",
          value: "LARGE",
        },
      ],
      rules: {
        level: [{ required: true, message: "请选择受灾程度", trigger: "blur" }],
      },
      degreeState: false,
    };
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    reportStatus: {
      type: Number,
    },
  },
  created() {
    this.$store.dispatch("getCurCompanyInfo").then((res) => {
      const {
        userCompany: { companyUserName },
      } = res;
      this.ruleForm.userName = companyUserName;
    });
    this.degreeStateFun();
  },
  methods: {
    ...mapActions("permission", ["hasPermission"]),
    setAcre(list) {
      let countNum = 0;
      list.forEach((ele) => {
        countNum = countNum + ele.statisticsLandAcre;
      });
      let res = countNum.toString().indexOf(".");
      if (res !== -1) {
        if (countNum.toString().substr(res + 1).length > 2) {
          countNum = countNum.toFixed(2);
        }
      }
      return countNum;
    },
    async checkContent(row) {
      if (await this.hasPermission("produce:disaster:repeat")) {
        this.$router.push({
          path: "/damage-increase-land",
          query: {
            id: this.$route.query.id,
            name: row.disasterName,
            landId: row.id,
          },
        });
      } else {
        this.$message({
          message: "您的权限无法使用该功能，可联系超级管理员修改权限",
          type: "warning",
        });
      }
    },
    async openDialog(parems) {
      const { id } = parems;
      this.ruleForm.id = id;
      switch (parems.level) {
        case "MEDIUM":
          this.option.splice(0, 1);
          break;
        default:
          break;
      }
      this.dialogVisible = true;
    },
    handleClose() {
      this.$refs.ruleForm.resetFields();
      this.option = [
        {
          label: "成灾",
          value: "MEDIUM",
        },
        {
          label: "绝收",
          value: "LARGE",
        },
      ];
      this.dialogVisible = false;
    },
    submitData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.raisedLevelFun();
        } else {
          return false;
        }
      });
    },
    async raisedLevelFun() {
      try {
        await raisedLevel(this.ruleForm);
      } catch (error) {
        console.log(error);
      } finally {
        this.handleClose();
        this.$emit("getList");
      }
    },
    async degreeStateFun() {
      try {
        this.degreeState = await this.hasPermission("produce:disaster:degree");
      } catch (error) {
        console.log(error);
      }
    },
    isShowBtntwo(parems) {
      if (!this.degreeState) return false;
      if (this.reportStatus === 2) return false;
      let state =
        parems.countyReviewStatus == 2 ||
        parems.cityReviewStatus == 2 ||
        parems.townReviewStatus == 2 ||
        parems.level == "LARGE";
      return !state;
    },
  },
};
</script>

<style lang="scss" scoped>
.hasData {
  height: 100%;
  .imgWrap {
    width: 33px;
    height: 33px;
    border-radius: 3px;
    margin-right: 5px;
  }
  .status0 {
    color: #666666;
  }
  .status1 {
    color: $--color-primary;
  }
  .status2 {
    color: red;
  }
}
.noDataImg {
  height: calc(100vh - 540px);
}
.totalLands {
  line-height: 70px;
  display: flex;
  flex-direction: row;
  .textColor {
    color: #ccc;
  }
}

.title_p {
  font-size: 16px;
  color: #b1b1b1;
  padding-bottom: 20px;
  padding-left: 25px;
}
</style>
